var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-text"},[_c('h1',[_vm._v("A reset password link has been sent to your email.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Return Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }